import React from 'react'

export default class NoDataComponent extends React.Component {
  render () {
    return (
      <div className='no-data-container'>
        <span className='no-data-text'>No se encontraron pacientes ¿Qué deseas hacer?</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Search/NotDataAvailable.js